import { Link } from "react-router-dom";
import type { Work } from "@/mocks/works";

interface WorkCardProps {
  work: Work;
}

export default function WorkCard({ work }: WorkCardProps) {
  const typeLabel = work.type === "movie" ? "电影" : "电视剧";

  return (
    <Link
      to={`/works/detail/${work.id}`}
      className="group block rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} 海报`}
          title={`${work.title} - 叶山小百合影视作品`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/10 to-transparent"></div>
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-accent-500 text-accent-950 text-xs font-medium">
          {typeLabel}
        </span>
        {work.rating > 0 && (
          <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-primary-950/70 text-background-50 text-xs font-medium">
            {work.rating.toFixed(1)}
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
          <h3 className="font-heading text-sm md:text-base font-semibold text-background-50 leading-snug line-clamp-2">
            {work.title}
          </h3>
          <p className="mt-1 text-xs text-background-50/70">
            {work.year} · {work.genres.slice(0, 2).join(" / ")}
          </p>
        </div>
      </div>
      <div className="px-3 py-3 border-t border-background-100">
        <p className="text-xs text-foreground-500 line-clamp-1">{work.role}</p>
      </div>
    </Link>
  );
}